import React, { useMemo } from 'react';
import PageShell from '../../components/PageShell';
import { useP } from '../../i18n/useP';
import { usePersistentValue } from '../../hooks/usePersistentState';
import ForecastBalanceSheetTab from '../ForecastBalanceSheetTab';
import VatYearPage from './VatYearPage';
import WorkingCapitalSynthesis from './WorkingCapitalSynthesis';

/* PLANIFICATION › FONDS DE ROULEMENT (décision Olivier, 2026-09-30) : les
   postes du cycle d'exploitation réunis en une section, créances clients,
   fournisseurs, acomptes clients, TVA et stocks. Ce sont les mêmes écrans que
   les détails du plan de liquidité en Pro, qui les lit ; la section demande
   Finance, et se lit grisée, cadenas, chez un client qui ne l'a pas. */

const TABS = [
  { id: 'synthesis', label: 'Synthèse' },
  { id: 'clients', label: 'Créances clients' },
  { id: 'suppliers', label: 'Fournisseurs' },
  { id: 'advances', label: 'Acomptes clients' },
  { id: 'vat', label: 'TVA' },
  { id: 'stock', label: 'Stocks' },
];
const FOCUS = { clients: 'pos-clients', suppliers: 'pos-fourn', advances: 'pos-advances', stock: 'pos-stock' };

export default function WorkingCapitalPage({ activeTenant, year }) {
  const p = useP();
  const tid = activeTenant?.id;
  const [tab, setTab] = usePersistentValue(`fin_wc_tab_${tid}`, 'synthesis');
  const [unit, setUnit] = usePersistentValue(`fin_wc_unit_${tid}`, 'kchf');
  const pageUnit = useMemo(() => ({ value: unit, onChange: setUnit }), [unit, setUnit]);
  const cur = TABS.some((t) => t.id === tab) ? tab : 'synthesis';
  const views = useMemo(() => [{
    id: 'poste', kind: 'segmented', label: p('Poste'), value: cur, onChange: setTab,
    options: TABS.map((t) => ({ id: t.id, label: p(t.label) })),
  }], [p, cur, setTab]);

  return (
    <PageShell kind="entry" title={p('Fonds de roulement')} unit={pageUnit} views={views}>
      {cur === 'synthesis'
        ? <WorkingCapitalSynthesis activeTenant={activeTenant} year={year} unit={unit} onOpenTab={setTab} />
        : cur === 'vat'
        ? <VatYearPage activeTenant={activeTenant} year={year} unit={unit} />
        : <ForecastBalanceSheetTab key={cur} focus={FOCUS[cur]} activeTenant={activeTenant} year={year} unit={unit} />}
    </PageShell>
  );
}
